/* DigiCrest theme script: quote list, catalog filters, product page, cart add. No dependencies. */
(() => {
  const DC = window.DC || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = cents => new Intl.NumberFormat('en-CA', { style: 'currency', currency: DC.currency || 'CAD' }).format(cents / 100);
  const TYPES = {
    'NVMe SSD': { sub: 'M.2 2280 · PCIe 3.0 / 4.0', g: 'g-m2' },
    'SATA SSD': { sub: '2.5-inch · 7 mm', g: 'g-sata' },
    'Desktop Memory': { sub: 'DDR4 · DDR5 UDIMM', g: 'g-dimm' },
    'Laptop Memory': { sub: 'DDR4 · DDR5 SODIMM', g: 'g-sodimm' },
    'Accessories': { sub: 'Flash · peripherals · safety', g: 'g-acc' }
  };
  const TYPE_ORDER = Object.keys(TYPES);
  const glyph = ty => `<svg><use href="#${(TYPES[ty] || TYPES['Accessories']).g}"/></svg>`;

  /* ---------- toast ---------- */
  let tt;
  function toast(m) { const t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 1900); }

  /* ---------- quote list (this device) ---------- */
  const KEY = 'dc-quote-v2';
  let quote = [];
  try { quote = JSON.parse(localStorage.getItem(KEY) || '[]').filter(i => i && i.h && i.q > 0); } catch (e) {}
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(quote)); } catch (e) {} };
  const qOf = h => (quote.find(x => x.h === h) || {}).q || 0;
  const watchers = [];
  function setQ(item, q) {
    q = Math.max(0, Math.min(9999, parseInt(q, 10) || 0));
    const i = quote.find(x => x.h === item.h);
    if (q) { if (i) i.q = q; else quote.push({ h: item.h, t: item.t, sku: item.sku || '', u: item.u || '', img: item.img || '', ty: item.ty || '', pr: item.pr || null, q }); }
    else quote = quote.filter(x => x.h !== item.h);
    save(); renderDrawer(); watchers.forEach(f => f(item.h));
  }
  const itemFrom = el => ({ h: el.dataset.h, t: el.dataset.t, sku: el.dataset.sku, u: el.dataset.u, img: el.dataset.img, ty: el.dataset.ty, pr: Number(el.dataset.pr) || null });

  /* ---------- drawer ---------- */
  const drawer = $('#drawer');
  function openDrawer() { if (!drawer) return; drawer.classList.add('on'); $('#scrim').classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('on'); $('#scrim').classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  const stepper = (h, q) => `<div class="stp"><button type="button" data-dec="${esc(h)}" aria-label="Decrease">−</button><input type="number" min="0" value="${q}" data-qty="${esc(h)}" aria-label="Quantity"><button type="button" data-inc="${esc(h)}" aria-label="Increase">+</button></div>`;
  function renderDrawer() {
    const units = quote.reduce((s, i) => s + i.q, 0);
    const nt = $('#n-top'); if (nt) { if (nt.textContent !== String(units) && nt.dataset.init) setTimeout(() => bump($('#open-quote')), reduced ? 0 : 600); nt.textContent = units; nt.dataset.init = 1; }
    if (!drawer) return;
    $('#n-drawer').textContent = `${quote.length} line${quote.length === 1 ? '' : 's'} · ${units} unit${units === 1 ? '' : 's'}`;
    const empty = !quote.length;
    ['#lines', '#tot', '#form', '#drawer-foot'].forEach(s => $(s).classList.toggle('hidden', empty));
    $('#empty-o').classList.toggle('hidden', !empty);
    if (empty) return;
    $('#lines').innerHTML = quote.map(i => `<li class="line">
      <a class="im" href="${esc(i.u)}">${i.img ? `<img src="${esc(i.img)}" alt="">` : glyph(i.ty)}</a>
      <div><div class="t">${esc(i.t)}</div><div class="s">${i.sku ? esc(i.sku) : 'Part no. on quote'}</div></div>
      ${stepper(i.h, i.q)}
      <button class="rm" type="button" data-rm="${esc(i.h)}">Remove</button>
      <div class="p">${i.pr ? `${money(i.pr * i.q)}<small>list</small>` : 'on quote'}</div></li>`).join('');
    const priced = quote.filter(i => i.pr), est = priced.reduce((s, i) => s + i.pr * i.q, 0);
    $('#tot').innerHTML = priced.length
      ? `<span>List total<small>${priced.length < quote.length ? 'priced lines only · ' : ''}volume pricing on the formal quote</small></span><b>${money(est)}</b>`
      : `<span>Total<small>priced on the formal quote</small></span><b>${units} unit${units === 1 ? '' : 's'}</b>`;
  }
  if (drawer) {
    $('#open-quote')?.addEventListener('click', openDrawer);
    $('#close-quote').addEventListener('click', closeDrawer);
    $('#scrim').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); closeSide(); closeMenu(); } });
    const byH = h => quote.find(x => x.h === h);
    $('#lines').addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      if (b.dataset.rm) setQ(byH(b.dataset.rm), 0);
      else if (b.dataset.inc) setQ(byH(b.dataset.inc), qOf(b.dataset.inc) + 1);
      else if (b.dataset.dec) setQ(byH(b.dataset.dec), qOf(b.dataset.dec) - 1);
    });
    $('#lines').addEventListener('change', e => { const h = e.target.dataset.qty; if (h) setQ(byH(h), e.target.value); });

    /* submit through Shopify's contact form: the email lands in the store inbox */
    const form = $('#quote-form');
    const makeRef = () => { const d = new Date(); const ymd = String(d.getFullYear()).slice(2) + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0'); const a = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; let s = ''; for (let i = 0; i < 4; i++) s += a[Math.floor(Math.random() * a.length)]; return `DC-${ymd}-${s}`; };
    form.addEventListener('submit', e => {
      if (!quote.length) { e.preventDefault(); return; }
      const req = $$('[required]', form);
      req.forEach(i => i.style.borderColor = '');
      const bad = req.filter(i => !i.value.trim() || (i.type === 'email' && !/^\S+@\S+\.\S+$/.test(i.value)));
      if (bad.length) { e.preventDefault(); bad.forEach(i => i.style.borderColor = 'var(--warn)'); bad[0].focus(); toast('Fill in the highlighted fields to send.'); return; }
      const ref = makeRef();
      const lines = quote.map(i => `${String(i.q).padStart(4, ' ')} × ${i.t}  [${i.sku || 'part no. on quote'}]${i.pr ? `  list ${money(i.pr)}/u` : ''}`);
      const units = quote.reduce((s, i) => s + i.q, 0);
      const text = [`QUOTE REQUEST ${ref}`, '', ...lines, '', `${quote.length} lines · ${units} units`].join('\n');
      $('#f-ref').value = ref; $('#f-lines').value = lines.join(' | '); $('#f-body').value = text;
      try { sessionStorage.setItem('dc-pending', JSON.stringify({ ref, text, at: Date.now() })); } catch (e) {}
      const btn = $('#send'); btn.textContent = 'Sending…'; setTimeout(() => { btn.disabled = true; }, 0);
    });
    /* after the round trip */
    const done = $('#done');
    let pending = null; try { pending = JSON.parse(sessionStorage.getItem('dc-pending') || 'null'); } catch (e) {}
    if (pending && Date.now() - pending.at > 1800000) pending = null;
    if (pending && done.dataset.posted === 'true') {
      try { sessionStorage.removeItem('dc-pending'); } catch (e) {}
      quote = []; save();
      $('#drawer-body').classList.add('hidden'); $('#drawer-foot').classList.add('hidden'); done.classList.remove('hidden');
      done.innerHTML = `<h3>Quote request sent.</h3><div class="ref">${esc(pending.ref)}</div>
        <p>We have it. Keep the reference for your records. A copy of the request is below.</p>
        <ol><li>A formal quote arrives within one business day.</li><li>Approve it, or send a purchase order.</li><li>Pay by Interac e-Transfer or EFT; we ship with tracking.</li></ol>
        <div class="acts"><button class="btn btn-ghost" type="button" id="copy-req">Copy request text</button><button class="btn btn-aqua" type="button" id="new-list">Start a new list</button></div>`;
      $('#copy-req').addEventListener('click', async () => { try { await navigator.clipboard.writeText(pending.text); toast('Request text copied'); } catch (e) { toast('Select and copy manually'); } });
      $('#new-list').addEventListener('click', () => { done.classList.add('hidden'); $('#drawer-body').classList.remove('hidden'); renderDrawer(); closeDrawer(); });
      history.replaceState(null, '', location.pathname);
      openDrawer();
    } else if (pending && done.dataset.errors === 'true') {
      openDrawer();
    }
  }
  renderDrawer();
  document.addEventListener('click', e => { const a = e.target.closest('[data-open-quote]'); if (a) { e.preventDefault(); openDrawer(); } });
  document.addEventListener('click', e => { const a = e.target.closest('[data-open-bulk]'); if (a) { e.preventDefault(); openDrawer(); const d = $('#bulk'); if (d) { d.open = true; setTimeout(() => $('#bulk-in').focus(), 250); } } });

  /* ---------- paste a parts list: "PART QTY" per line, matched against the catalog index ---------- */
  const bulkBtn = $('#bulk-add');
  if (bulkBtn) {
    const norm = s => String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    let index = null;
    const loadIndex = async () => {
      if (index) return index;
      const th = window.Shopify && Shopify.theme; const r = await fetch(DC.routes.index + (th && th.role !== 'main' ? '&preview_theme_id=' + th.id : ''));
      index = await r.json(); return index;
    };
    const parse = line => {
      const toks = line.replace(/[,;\t]+/g, ' ').replace(/\b(\d{1,4})\s*[x×]\s+/i, '$1 ').replace(/\s+[x×]\s*(\d{1,4})\b/i, ' $1').trim().split(/\s+/).filter(Boolean);
      if (!toks.length) return null;
      let q = 1; const qi = toks.findIndex(t => /^\d{1,4}(pcs|pc|units|u)?$/i.test(t) && toks.length > 1);
      if (qi > -1) { q = parseInt(toks[qi], 10) || 1; toks.splice(qi, 1); }
      return { raw: toks.join(' '), q };
    };
    bulkBtn.addEventListener('click', async () => {
      const ta = $('#bulk-in'), msg = $('#bulk-msg');
      const rows = ta.value.split(/\n+/).map(parse).filter(Boolean);
      if (!rows.length) { msg.textContent = 'Paste at least one part number.'; return; }
      bulkBtn.disabled = true; msg.textContent = 'Matching…';
      let idx = [];
      try { idx = await loadIndex(); } catch (e) {}
      let hit = 0; const miss = [];
      rows.forEach(({ raw, q }) => {
        const k = norm(raw);
        let p = idx.find(x => x.sku && norm(x.sku) === k);
        if (!p && k.length >= 5) { const c = idx.filter(x => x.sku && norm(x.sku).startsWith(k)); if (c.length === 1) p = c[0]; }
        if (p) { setQ(p, qOf(p.h) + q); hit++; }
        else { const h = 'x-' + (k || raw).toLowerCase(); setQ({ h, t: 'Not in catalog: ' + raw, sku: raw, ty: 'Accessories' }, qOf(h) + q); miss.push(raw); }
      });
      bulkBtn.disabled = false;
      msg.textContent = `${hit} matched${miss.length ? ` · ${miss.length} we will source: ${miss.slice(0, 3).join(', ')}${miss.length > 3 ? '…' : ''}` : ''}`;
      if (!miss.length) { ta.value = ''; }
    });
  }

  /* ---------- copy part number ---------- */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-copy]'); if (!b) return;
    e.preventDefault();
    try { await navigator.clipboard.writeText(b.dataset.copy); toast('Part number copied: ' + b.dataset.copy); } catch (err) { toast(b.dataset.copy); }
  });

  /* ---------- add feedback: image flies to the header icon, icon bumps ---------- */
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fly(from, to) {
    if (!from || !to || reduced) return;
    const img = from.closest('.card,.row,[data-product]')?.querySelector('.pl img,.im img,#gal-main img');
    const a = (img || from).getBoundingClientRect(), b = to.getBoundingClientRect();
    if (!b.width) return;
    const g = document.createElement('div'); g.className = 'fly';
    if (img) g.style.backgroundImage = `url("${img.currentSrc || img.src}")`;
    const sz = Math.min(a.width, a.height, 120) || 40;
    Object.assign(g.style, { width: sz + 'px', height: sz + 'px', left: a.left + a.width / 2 - sz / 2 + 'px', top: a.top + a.height / 2 - sz / 2 + 'px' });
    document.body.appendChild(g);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    g.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: `translate(${dx * .5}px,${dy - 60}px) scale(.6)`, opacity: 1, offset: .55 }, { transform: `translate(${dx}px,${dy}px) scale(.15)`, opacity: .3 }],
      { duration: 650, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = () => { g.remove(); bump(to); };
  }
  function bump(el) { if (!el) return; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  function btnState(b, html, cls, ms) {
    if (!b) return;
    if (!b.dataset.label) b.dataset.label = b.innerHTML;
    b.innerHTML = html; b.classList.add(cls);
    if (ms) setTimeout(() => { b.innerHTML = b.dataset.label; b.classList.remove(cls); delete b.dataset.label; }, ms);
  }
  const CHECK = '<svg class="ck" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ---------- cart ---------- */
  const mini = document.createElement('div');
  mini.className = 'mini'; mini.setAttribute('role', 'status'); mini.setAttribute('aria-live', 'polite');
  document.body.appendChild(mini);
  let mt;
  function showMini(info, qty, c) {
    mini.innerHTML = `<div class="mh">${CHECK}<b>Added to cart</b><button type="button" class="mx" aria-label="Close">×</button></div>
      <div class="mb">${info.img ? `<img src="${esc(info.img)}" alt="">` : ''}<div><div class="mt">${esc(info.t || '')}</div><div class="mq">Qty ${qty}${info.pr ? ` · ${money(info.pr * qty)}` : ''}</div></div></div>
      <div class="ms"><span>Cart subtotal · ${c.item_count} item${c.item_count === 1 ? '' : 's'}</span><b>${money(c.total_price)}</b></div>
      <div class="ma"><a class="btn btn-ghost" href="${esc(DC.routes.cart)}">View cart</a><a class="btn btn-aqua" href="/checkout">Checkout</a></div>`;
    const hdr = $('.hdr'); const hb = hdr ? hdr.getBoundingClientRect().bottom : 0;
    mini.style.top = innerWidth > 640 ? Math.max(16, hb + 12) + 'px' : '';
    mini.classList.add('on');
    mini.querySelector('.mx').onclick = () => mini.classList.remove('on');
    clearTimeout(mt); mt = setTimeout(() => mini.classList.remove('on'), 6000);
  }
  mini.addEventListener('mouseenter', () => clearTimeout(mt));
  mini.addEventListener('mouseleave', () => { mt = setTimeout(() => mini.classList.remove('on'), 2500); });
  function infoFrom(b) {
    const host = b.closest('.card,.row,[data-product]');
    if (!host) return {};
    if (host.matches('[data-product]')) return { t: host.dataset.t, img: host.dataset.img, pr: Number(host.dataset.pr) || 0 };
    const img = host.querySelector('.pl img,.im img');
    const t = host.querySelector('h4 a,.t > a')?.textContent || '';
    const eb = host.querySelector('.eb')?.textContent.split('·')[0].trim() || '';
    const pr = parseFloat((host.querySelector('.pr')?.textContent || '').replace(/[^0-9.]/g, '')) * 100 || 0;
    return { t: (eb && !t.startsWith(eb) ? eb + ' ' : '') + t, img: img?.currentSrc || img?.src, pr };
  }
  async function cartAdd(vid, qty, b) {
    if (b?.classList.contains('busy')) return;
    btnState(b, '<span class="spin"></span>Adding', 'busy');
    try {
      const r = await fetch(DC.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] }) });
      const j = await r.json();
      if (b) { b.innerHTML = b.dataset.label; b.classList.remove('busy'); delete b.dataset.label; }
      if (!r.ok) { toast(j.description || 'Could not add to cart'); return; }
      const c = await (await fetch('/cart.js')).json();
      const link = $('.hdr .cart-link:not(.acct)');
      fly(b, link);
      setTimeout(() => { const n = $('#n-cart'); if (n) { n.textContent = c.item_count; n.hidden = !c.item_count; } }, reduced ? 0 : 600);
      btnState(b, CHECK + 'Added', 'ok', 1800);
      showMini(infoFrom(b), qty, c);
    } catch (err) { if (b) { b.innerHTML = b.dataset.label || b.innerHTML; b.classList.remove('busy'); delete b.dataset.label; } toast('Could not add to cart'); }
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-cart-add]'); if (!b) return;
    cartAdd(b.dataset.cartAdd, 1, b);
  });

  /* ---------- server-rendered "Add" buttons (related, search) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-quote-add]'); if (!b) return;
    const it = itemFrom(b); fly(b, $('#open-quote')); setQ(it, qOf(it.h) + 1);
    b.textContent = `In quote · ${qOf(it.h)}`; toast('Added to quote: ' + it.t);
  });

  /* ---------- mobile menu ---------- */
  const mnav = $('#mnav');
  function closeMenu() { if (mnav) { mnav.classList.remove('on'); mnav.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  $('#open-menu')?.addEventListener('click', () => { mnav.classList.add('on'); mnav.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; });
  $('#close-menu')?.addEventListener('click', closeMenu);
  mnav?.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });

  /* ---------- product page ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    const qi = $('#pdp-qty');
    const qty = () => Math.max(1, Math.min(9999, parseInt(qi.value, 10) || 1));
    $('[data-pdp-inc]').addEventListener('click', () => { qi.value = qty() + 1; });
    $('[data-pdp-dec]').addEventListener('click', () => { qi.value = Math.max(1, qty() - 1); });
    const it = itemFrom(pdp);
    $$('[data-pdp-quote]').forEach(b => b.addEventListener('click', () => { fly(b, $('#open-quote')); setQ(it, qOf(it.h) + qty()); btnState(b, CHECK + 'Added to quote', 'ok', 1800); toast(`Added to quote: ${qty()} × ${it.t}`); }));
    $('[data-pdp-volume]').addEventListener('click', e => { e.preventDefault(); if (!qOf(it.h)) setQ(it, qty()); openDrawer(); setTimeout(() => $('#f-notes')?.focus(), 250); });
    $('[data-pdp-cart]')?.addEventListener('click', e => cartAdd(pdp.dataset.vid, qty(), e.currentTarget));
    $$('.gal .thumbs button').forEach(b => b.addEventListener('click', () => {
      const img = $('#gal-main img'); if (img) { img.srcset = ''; img.src = b.dataset.src; }
      $$('.gal .thumbs button').forEach(x => x.removeAttribute('aria-current')); b.setAttribute('aria-current', 'true');
    }));
  }

  /* ---------- catalog ---------- */
  const dataEl = $('#catalog-data');
  const side = $('#side');
  function closeSide() { if (side) { side.classList.remove('on'); document.body.style.overflow = ''; } }
  if (dataEl) {
    let P = [];
    try { P = JSON.parse(dataEl.textContent); } catch (e) {}
    const scope = $('#catalog').dataset.scope;
    const capLabel = p => { const n = p.cap; if (!n) return ''; if (/Memory/.test(p.ty) || n < 1000) return `${Math.round(n)} GB`; const t = n / 1000; return `${t % 1 ? t.toFixed(1) : t} TB`; };
    const speed = v => String(v || '').replace(/^up to\s*/i, '').replace(/\b(\d{4,5})\b/g, m => Number(m).toLocaleString('en-CA'));
    const spec = p => [capLabel(p), p.if, p.ff, speed(p.sp), p.nt].filter(Boolean).join(' · ');
    const short = p => p.t.toLowerCase().startsWith(p.b.toLowerCase() + ' ') ? p.t.slice(p.b.length + 1) : p.t;
    P.forEach((p, i) => { p.i = i; p.cl = capLabel(p); p.hay = `${p.b} ${p.s} ${p.t} ${p.sku} ${p.if} ${p.ff} ${p.cl} ${p.nt} ${p.ty}`.toLowerCase(); });
    const typeIdx = t => { const i = TYPE_ORDER.indexOf(t); return i < 0 ? 99 : i; };
    const base = (a, b) => typeIdx(a.ty) - typeIdx(b.ty) || a.b.localeCompare(b.b) || String(a.s).localeCompare(String(b.s)) || (a.cap || 0) - (b.cap || 0);
    P.sort(base);

    const st = { ty: 'all', b: new Set(), f: new Set(), c: new Set(), p: new Set(), q: '', sort: 'cat', view: 'grid' };
    const BANDS = [['Under $50', 5000], ['$50 – $100', 10000], ['$100 – $200', 20000], ['$200 and up', Infinity]];
    const priceBand = p => p.lp ? BANDS.find(b => p.lp < b[1])[0] : '';
    try { st.view = localStorage.getItem('dc-view') || 'grid'; } catch (e) {}
    const FACETS = [
      { k: 'b', name: 'Brand', val: p => p.b },
      { k: 'c', name: 'Capacity', val: p => p.cl, ord: (a, b) => P.find(p => p.cl === a).cap - P.find(p => p.cl === b).cap },
      { k: 'f', name: 'Interface', val: p => p.if },
      { k: 'p', name: 'Price', val: p => priceBand(p), ord: (a, b) => BANDS.findIndex(x => x[0] === a) - BANDS.findIndex(x => x[0] === b) }
    ];
    const match = (p, skip) => {
      if (skip !== 'ty' && st.ty !== 'all' && p.ty !== st.ty) return false;
      for (const F of FACETS) { if (skip !== F.k && st[F.k].size && !st[F.k].has(F.val(p))) return false; }
      if (st.q && !st.q.split(/\s+/).every(t => p.hay.includes(t))) return false;
      return true;
    };

    function renderFacets() {
      let h = '';
      if (scope === 'all') {
        const types = TYPE_ORDER.concat([...new Set(P.map(p => p.ty))].filter(t => !TYPE_ORDER.includes(t)));
        const pool = P.filter(p => match(p, 'ty'));
        h += `<div class="fg"><h5>Category</h5>` + [['all', 'All products', pool.length], ...types.map(t => [t, t, pool.filter(p => p.ty === t).length])]
          .map(([v, n, c]) => `<label class="fo${c ? '' : ' zero'}"><input type="radio" name="f-ty" value="${esc(v)}"${st.ty === v ? ' checked' : ''}>${esc(n)}<span class="c">${c}</span></label>`).join('') + `</div>`;
      }
      FACETS.forEach(F => {
        const pool = P.filter(p => match(p, F.k));
        let vals = [...new Set(P.filter(p => st.ty === 'all' || p.ty === st.ty).map(F.val).filter(Boolean))];
        vals.sort(F.ord || ((a, b) => a.localeCompare(b)));
        if (vals.length < 2 && !st[F.k].size) return;
        h += `<div class="fg"><h5>${F.name}</h5>` + vals.map(v => { const c = pool.filter(p => F.val(p) === v).length; return `<label class="fo${c ? '' : ' zero'}"><input type="checkbox" data-f="${F.k}" value="${esc(v)}"${st[F.k].has(v) ? ' checked' : ''}>${esc(v)}<span class="c">${c}</span></label>`; }).join('') + `</div>`;
      });
      $('#facets').innerHTML = h;
      const n = st.b.size + st.c.size + st.f.size + st.p.size + (st.ty !== 'all' ? 1 : 0);
      const nb = $('#n-filters'); nb.textContent = n; nb.hidden = !n;
      const mc = $('#mchips');
      if (scope === 'all') {
        const types = TYPE_ORDER;
        mc.innerHTML = [['all', 'All'], ...types.map(t => [t, t])].map(([v, n]) => `<button type="button" class="chip" data-ty="${esc(v)}" aria-pressed="${st.ty === v}">${esc(n)}</button>`).join('');
      } else mc.innerHTML = '';
    }

    function cardHTML(p) {
      const q = qOf(p.h);
      const pn = p.sku ? `<button class="pnc" type="button" data-copy="${esc(p.sku)}" title="Copy part number">${esc(p.sku)}<svg><use href="#i-copy"/></svg></button>` : `<span class="pnc tbd">Part no. on quote</span>`;
      const av = `<span class="av${p.ao ? ' ord' : ''}">${esc(p.av || 'In stock')}</span>`;
      const price = p.lp ? `<div class="pr">${money(p.lp)}<small>CAD · EXCL. TAX</small></div>` : `<div class="pr q">Quote</div>`;
      const act = p.buy ? `<button class="btn-cart" type="button" data-cart-add="${p.vid}">Add to cart</button>` : (q ? stepper(p.h, q) : `<button class="add" type="button" data-add="${esc(p.h)}">Add</button>`);
      if (st.view === 'list') {
        return `<div class="row${q ? ' in' : ''}" data-h="${esc(p.h)}">
          <a class="im" href="${esc(p.u)}">${p.img ? `<img src="${esc(p.img)}" alt="" loading="lazy">` : glyph(p.ty)}</a>
          <div class="t"><div class="eb">${esc(p.b)}${p.s ? ' · ' + esc(p.s) : ''}</div><a href="${esc(p.u)}">${esc(short(p))}</a><div style="margin-top:6px">${pn}</div></div>
          <div class="spc">${esc(spec(p))}</div>
          <div class="avc">${av}</div>
          <div class="prc">${price}</div>
          <div class="act">${act}</div></div>`;
      }
      return `<article class="card${q ? ' in' : ''}" data-h="${esc(p.h)}">
        ${q ? `<span class="tg">In quote · ${q}</span>` : ''}
        <div class="ct">${pn}${av}</div>
        <a class="pl" href="${esc(p.u)}">${p.img ? `<img src="${esc(p.img)}" alt="${esc(p.t)}" loading="lazy">` : glyph(p.ty)}</a>
        <div class="cb">
          <div class="eb">${esc(p.b)}${p.s ? ' · ' + esc(p.s) : ''}</div>
          <h4><a href="${esc(p.u)}">${esc(short(p))}</a></h4>
          <div class="sp">${esc(spec(p))}</div>
          <div class="cf">${price}${act}</div>
          ${p.buy ? `<button class="alt" type="button" data-add="${esc(p.h)}">${q ? `In quote · ${q}` : 'Add to quote for volume'}</button>` : ''}
        </div></article>`;
    }
    const SORTS = {
      cat: base,
      brand: (a, b) => a.b.localeCompare(b.b) || base(a, b),
      'cap-asc': (a, b) => (a.cap || 1e9) - (b.cap || 1e9) || base(a, b),
      'cap-desc': (a, b) => (b.cap || 0) - (a.cap || 0) || base(a, b),
      sku: (a, b) => (a.sku || '~').localeCompare(b.sku || '~'),
      'pr-asc': (a, b) => (a.lp || 1e12) - (b.lp || 1e12) || base(a, b),
      'pr-desc': (a, b) => (b.lp || 0) - (a.lp || 0) || base(a, b)
    };
    if (!P.some(p => p.lp)) $$('#sort option[value^="pr-"]').forEach(o => o.remove());
    function renderList() {
      const vis = P.filter(p => match(p)).sort(SORTS[st.sort]);
      const wrapItems = items => st.view === 'list'
        ? `<div class="rows"><div class="rows-h"><span></span><span>Product</span><span>Specs</span><span class="avc">Availability</span><span>Price</span><span></span></div>${items.map(cardHTML).join('')}</div>`
        : `<div class="grid-p">${items.map(cardHTML).join('')}</div>`;
      let html = '';
      if (st.sort === 'cat' && scope === 'all') {
        TYPE_ORDER.concat([...new Set(vis.map(p => p.ty))].filter(t => !TYPE_ORDER.includes(t))).forEach(t => {
          const ps = vis.filter(p => p.ty === t); if (!ps.length) return;
          html += `<section class="group"><div class="gh"><h3>${esc(t)}</h3><span>${esc((TYPES[t] || {}).sub || '')} · ${ps.length} product${ps.length > 1 ? 's' : ''}</span></div>${wrapItems(ps)}</section>`;
        });
      } else if (vis.length) html = `<div class="group">${wrapItems(vis)}</div>`;
      const soon = !P.some(p => st.ty === 'all' || p.ty === st.ty);
      $('#list').innerHTML = html || (soon ? `<div class="empty">Coming soon. Need something in this category? <button type="button" data-open-quote>Ask us to source it</button>.</div>` : '') || `<div class="empty">No parts match those filters. <button type="button" data-clear>Clear filters</button> or <button type="button" data-open-quote>ask us to source it</button>.</div>`;
      $('#cnt').textContent = `${vis.length} of ${P.length} products`;
      const sum = $('#list-sum');
      if (sum && !sum.dataset.init) { sum.dataset.init = '1'; if (!sum.textContent.trim()) { const bs = new Set(P.map(p => p.b)); sum.textContent = `${P.length} products · ${bs.size} brands · retail-boxed, warranty intact · wholesale, quoted in CAD`; } }
      $$('.views button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.view === st.view)));
    }
    const rerender = () => { renderFacets(); renderList(); };
    rerender();

    const byH = h => P.find(p => p.h === h);
    const asItem = p => ({ h: p.h, t: p.t, sku: p.sku, u: p.u, img: p.img, ty: p.ty, pr: p.lp });
    watchers.push(h => { const p = byH(h); const el = $(`#list [data-h="${CSS.escape(h)}"]`); if (p && el) el.outerHTML = cardHTML(p); });
    $('#list').addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      if (b.dataset.add) { const p = byH(b.dataset.add); fly(b, $('#open-quote')); setQ(asItem(p), qOf(p.h) + 1); toast('Added to quote: ' + p.t); }
      else if (b.dataset.inc) { const p = byH(b.dataset.inc); setQ(asItem(p), qOf(p.h) + 1); }
      else if (b.dataset.dec) { const p = byH(b.dataset.dec); setQ(asItem(p), qOf(p.h) - 1); }
    });
    $('#list').addEventListener('change', e => { const h = e.target.dataset.qty; if (h) setQ(asItem(byH(h)), e.target.value); });
    $('#facets').addEventListener('change', e => {
      const i = e.target;
      if (i.name === 'f-ty') st.ty = i.value;
      else if (i.dataset.f) { const s = st[i.dataset.f]; i.checked ? s.add(i.value) : s.delete(i.value); }
      rerender();
    });
    $('#mchips').addEventListener('click', e => { const b = e.target.closest('[data-ty]'); if (b) { st.ty = b.dataset.ty; rerender(); } });
    document.addEventListener('click', e => {
      if (e.target.closest('[data-clear]')) { st.ty = 'all'; st.b.clear(); st.c.clear(); st.f.clear(); st.p.clear(); st.q = ''; $('#q').value = ''; const qt = $('#q-top'); if (qt) qt.value = ''; rerender(); }
      if (e.target.closest('[data-close-side]')) closeSide();
    });
    $('#open-side').addEventListener('click', () => { side.classList.add('on'); document.body.style.overflow = 'hidden'; });
    $('#sort').addEventListener('change', e => { st.sort = e.target.value; renderList(); });
    $$('.views button').forEach(b => b.addEventListener('click', () => { st.view = b.dataset.view; try { localStorage.setItem('dc-view', st.view); } catch (e) {} renderList(); }));
    const onQ = (src, other) => { st.q = src.value.trim().toLowerCase(); if (other) other.value = src.value; rerender(); };
    const qIn = $('#q'), qTop = $('#q-top');
    qIn.addEventListener('input', () => onQ(qIn, qTop));
    if (qTop) {
      qTop.addEventListener('input', () => { onQ(qTop, qIn); if (st.q) { const r = $('#catalog').getBoundingClientRect(); if (r.top > 300) $('#catalog').scrollIntoView({ behavior: 'smooth' }); } });
      qTop.form?.addEventListener('submit', e => { e.preventDefault(); $('#catalog').scrollIntoView({ behavior: 'smooth' }); });
    }
  }
})();
